import { jsx as _jsx } from "react/jsx-runtime";
import Tooltip from 'antd/es/tooltip';
const TooltipWrapper = ({ children, tooltip, }) => {
    if (!tooltip)
        return children;
    return _jsx(Tooltip, { title: tooltip, children: children });
};
export default TooltipWrapper;
